import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldEditChangedArgs, FieldEditChangingArgs, FieldWidthEnum } from '@data/cer-data-types';

export class AfregningsTabelLegacyForm extends CerFormAdapter {

    override viewSetInit(viewSet: CerFormViewSet): void {
        const linkCol = this.routeOptions.navigation?.columnNameChild?.toLowerCase();
        const view = AfregningsTabelLegacyForm.viewGet(linkCol);
        viewSet.viewAdd(view);
    }

    public static viewGet(hideColName: string): CerFormView {

        const showHid = hideColName != 'hid';
        const showFid = hideColName != 'fid';

        const view = new CerFormView();
        view.viewType = 'list';
        view.viewMetadata = {
            name: 'Afregning', dataApiName: 'Afregningstabel', dataApiParams: ['$includeForfatterNavigation'],
            text: 'Afregningsopsætninger', textSingular: 'Afregningsopsætning', allowSorting: false, allowFiltering: false,
            primaryKey: ['compositeKey' /* = 'ukontrakt§omkArt' workaround - EJ2 only has single field support */, 'ukontrakt', 'omkArt'],
            titleFields: ['hid'],
            navigations: [
                { link: 'nav', foreignKey: { entity: 'RefDataProduct', column: 'projectLegacyId', parentColumn: 'hid' } }
            ]
        };


        view.fieldMetadata =
            [{ name: 'compositeKey', text: 'Nøgle', required: true, visible: false, widthType: FieldWidthEnum.XXL, visibleAdd: false, allowEdit: false },
            {
                name: 'hid', text: 'Titel', required: true, widthType: FieldWidthEnum.XXXL,
                visible: showHid, visibleAdd: showHid, allowEdit: true,
                foreignKeyType: 'refDataProduct', foreignKeyField: 'projectLegacyId', foreignKeyValue: 'description'
            },
            {
                name: 'fid', text: 'Forfatter/Forlag/Agent', tooltipText: 'Reference til forfatter, forlag eller agent',
                required: true, widthType: FieldWidthEnum.XXXL,
                visible: showFid, visibleAdd: showFid, allowEdit: true,
                foreignKeyTableName: 'Forfatter', foreignKeyField: 'id', foreignKeyValue: 'idNavn', foreignKeyColumns: ['forfatterId', 'navn'], foreignKeyTitles: ['Nr.', 'Navn'], foreignKeyColumnsWidth: ['80px', '300px'], foreignKeyTableParams: ['$filterBlocked'],
                foreignKey: { dataOptions: { maintainFromRowNavigation: true } }, foreignKeyAllowFiltering: true,
                onEditChanging: (args) => { AfregningsTabelLegacyForm.forfatterChanging(args) },
                onEditChanged: (args) => { AfregningsTabelLegacyForm.forfatterChanged(args) }
            },
            {
                name: 'antal', text: 'Antal fra', tooltipText: 'Trappe antal fra',
                format: 'Integer', defaultValue: 0, required: true, widthType: FieldWidthEnum.XXS
            },
            {
                name: 'procent', text: '%', tooltipText: '% af omsætning til afregning',
                format: 'Amount', widthType: FieldWidthEnum.XXXS
            },
            {
                name: 'forskud', text: 'Forskud', tooltipText: 'Udbetalt forskud',
                format: 'Amount', widthType: FieldWidthEnum.XS
            },
            {
                name: 'currency', text: 'Valuta',
                widthType: FieldWidthEnum.XS,
                foreignKeyTableName: 'ValutaKoder', foreignKeyField: 'id', foreignKeyValue: 'valutaKode',
                onEditChanging: (args) => { AfregningsTabelLegacyForm.valutaChanging(args) },
                onEditChanged: (args) => { AfregningsTabelLegacyForm.valutaChanged(args) }
            },
            { name: 'sortKey', text: 'Sortering', widthType: FieldWidthEnum.S, visible: false },
            { name: 'logRef', text: 'Log ref.', format: 'Integer', visible: false },
            { name: 'kladde', text: 'Kladde', format: 'Integer', visible: false }
            ];

        return view;
    }

    static valutaChanging(args: FieldEditChangingArgs) {
        throw new Error('Method not implemented.');
    }

    static valutaChanged(args: FieldEditChangedArgs) {
        throw new Error('Method not implemented.');
    }

    static forfatterChanging(args: FieldEditChangingArgs) {
        throw new Error('Method not implemented.');
    }

    static forfatterChanged(args: FieldEditChangedArgs) {
        throw new Error('Method not implemented.');
    }

}